import React from 'react'
import { CircularProgress, HeroUIProvider } from "@heroui/react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { store, useAppSelector } from '@/app/store';

import { initTranslation } from '@/components/Languages/Languages';
import FlexRow from '@/components/Common/FlexRow';

import Home from '@/pages/Home/Home';
import Login from '@/pages/Login/Login';
import OnboardingWizard from '@/pages/Onboarding/OnboardingWizard';

const MSG_CLEAR_TIMEOUT = 10000;

function App() {
  initTranslation();
  
  const { t } = useTranslation();
  
  const logins = useAppSelector((state) => state.logins);
  const navigate = useNavigate();
  
  const errorTimer = React.useRef(null as ReturnType<typeof setTimeout> | null);
  const successTimer = React.useRef(null as ReturnType<typeof setTimeout> | null);

  React.useEffect(() => {
    if (errorTimer.current) {
      clearTimeout(errorTimer.current);
      errorTimer.current = null;
    }
    
    if (logins.error == '')
      return;
    
    errorTimer.current = setTimeout(() => store.dispatchError(""), MSG_CLEAR_TIMEOUT);
  }, [logins.error]);
  
  React.useEffect(() => {
    if (successTimer.current) {
      clearTimeout(successTimer.current);
      successTimer.current = null;
    }
    
    if (logins.success == '')
      return;
    
    successTimer.current = setTimeout(() => store.dispatchSuccess(""), MSG_CLEAR_TIMEOUT);
  }, [logins.success]);
  
  //console.log("App/logins=", logins);

  return (
  <HeroUIProvider navigate={navigate}>
    { logins.status == -1 &&
      <CircularProgress aria-label="loading" />
    }
    { logins.status == 0 &&
      <Login />
    }
    { logins.status == 1 &&
      ( !logins.login
          ? <CircularProgress aria-label="loading" />
          : ( logins.supports2FA &&
              !logins.login.totp_disabled &&
              !( logins.login.email_verified &&
                 (logins.login.totp_enrolled || logins.login.preferred_2fa_method === 'email') ) &&
              !logins.requires2FA
                ? <OnboardingWizard />
                : <Home />
            )
      )
    }
  {logins.error != '' &&
    <FlexRow flex={0}
             className={[
               'fixed',
               'bottom-[50px]',
               'z-[99999]',
               'm-0',
               'justify-center',
               'bg-white',
               'max-w-[300px]',
               'p-[8px]',
               'rounded-2',
               'toastNotification',
               'translate-x-[-50%]',
               'left-[50%]',
             ]}>
      <span className="material-icons !text-[--Error] text-[24px]">
        error
      </span>
      <FlexRow direction="column"
               align="start"
               className="ml-[8px]">
        <div className="b14">
          { t('header:error') }
        </div>
        <div className="r12">
          { logins.error }
        </div>
      </FlexRow>
      <div className="material-icons text-[--Mid-Grey] absolute top-0 right-0 text-[24px] cursor-pointer"
           onClick={() => store.dispatchError("")}>
        close
      </div>
    </FlexRow>
  }
  {logins.success != '' &&
    <FlexRow flex={0}
             className={[
               'fixed',
               'bottom-[100px]',
               'z-[99999]',
               'm-0',
               'justify-center',
               'bg-[--Primetime-main]',
               'max-w-[300px]',
               'p-[8px]',
               'rounded-2',
               'toastNotification',
               'translate-x-[-50%]',
               'left-[50%]',
             ]}>
      <span className="material-icons !text-white text-[24px]">
        error
      </span>
      <FlexRow direction="column"
               align="start"
               className="ml-[8px]">
        <div className="b14 text-white">
          { t('header:success') }
        </div>
        <div className="r12 text-white">
          { logins.success }
        </div>
      </FlexRow>
      <div className="material-icons text-[--Mid-Grey] absolute top-0 right-0 text-[24px] cursor-pointer"
           onClick={() => store.dispatchSuccess("")}>
        close
      </div>
    </FlexRow>
  }  </HeroUIProvider>
  )
}

export default App
